/* FERRY AUTO-GENERATED: DO NOT EDIT THIS FILE */
/* eslint-disable */
// @ts-nocheck

import { axiosFetch } from '@i18n-config/consumer';

import { method, headers, queryStringify } from '../_util';

export class ConfigCenter {
  constructor(uriPrefix) {
    this.uriPrefix = typeof uriPrefix !== 'undefined' ? uriPrefix : '';
  }

  GetConfig(request, option) {
    const query = queryStringify(request);
    const uri = `${this.uriPrefix}/api/v${request.version || 1}/arch/config_center_gw/get_config${query}`;
    return axiosFetch(uri, { method, headers }, option, request);
  }

  MGetConfigByAppName(request, option) {
    const query = queryStringify(request);
    const uri = `${this.uriPrefix}/api/v${
      request.version || 1
    }/arch/config_center_gw/mget_config_by_app_name${query}`;
    return axiosFetch(uri, { method, headers }, option, request);
  }

  MGetConfigByConfigName(request, option) {
    const query = queryStringify(request);
    const uri = `${this.uriPrefix}/api/v${
      request.version || 1
    }/arch/config_center_gw/mget_config_by_config_name${query}`;
    return axiosFetch(uri, { method, headers }, option, request);
  }
}

export const configCenterClient = new ConfigCenter();
